import React, { useState, useRef, useEffect } from 'react'
import { Button, Image } from 'antd'
import Styles from './index.module.scss'
import { MinusOutlined, PlusOutlined, RedoOutlined, UndoOutlined } from '@ant-design/icons'

export default function AppImageViewer ({ src }) {
  const [scale, setScale] = useState(1)
  const [rotation, setRotation] = useState(0)
  const [dragging, setDragging] = useState(false)
  const [position, setPosition] = useState({
    x: 0,
    y: 0
  })
  const containerRef = useRef(null)
  const [currentSrc, setCurrentSrc] = useState('')
  // 新增parentRef用于父容器
  const parentRef = useRef(null);

  useEffect(() => {
    handleRestore()
    setCurrentSrc(src)
  }, [src])

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      // 添加wheel事件监听器并设置passive: false以避免preventDefault错误
      container.addEventListener('wheel', handleWheel, { passive: false });
    }
    return () => {
      if (container) {
        container.removeEventListener('wheel', handleWheel, { passive: false });
      }
    };
  }, []); // 依赖项需要包含handleWheel函数

  const handleRestore = () => {
    setPosition({
      x: 0,
      y: 0
    })
    setRotation(0)
    setScale(1)
  }

  const initialPosition = useRef({ x: 0, y: 0 });
  const mousePosition = useRef({ x: 0, y: 0 });

  const handleMouseDown = (e) => {
    setDragging(true);
    initialPosition.current.x = position.x;
    initialPosition.current.y = position.y;
    mousePosition.current.x = e.clientX;
    mousePosition.current.y = e.clientY;

    document.addEventListener('mousemove', handleMouseMoveGlobal);
    document.addEventListener('mouseup', handleMouseUpGlobal);
  };

  const handleMouseMoveGlobal = (e) => {
    const dx = e.clientX - mousePosition.current.x;
    const dy = e.clientY - mousePosition.current.y;
    setPosition({
      x: initialPosition.current.x + dx,
      y: initialPosition.current.y + dy
    });
  };

  const handleMouseUpGlobal = () => {
    setDragging(false);
    document.removeEventListener('mousemove', handleMouseMoveGlobal);
    document.removeEventListener('mouseup', handleMouseUpGlobal);
  };

  const handleWheel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const delta = e.deltaY > 0 ? -0.02 : 0.02;
    setScale(prev => Math.min(2, Math.max(0.5, prev + delta)));
  }

  const updateScaleAction = (value) => {
    setScale(pre => pre + value)
  }

  const handleRotate = (value) => {
    setRotation(prev => prev + value)
  }

  return (
    <div ref={parentRef} className="w-100">
      <div className="py-2 px-3 d-flex align-center justify-content-center">
        <Button
          className="text-primary"
          type="text"
          onClick={ () => {
            updateScaleAction(0.3)
          } }>
          <PlusOutlined />
        </Button>

        <Button
          className="text-primary"
          type="text"
          onClick={ () => {
            updateScaleAction(-0.3)
          } }>
          <MinusOutlined />
        </Button>

        <Button
          className="text-primary"
          type="text"
          onClick={ () => {
            handleRotate(90)
          } }>
          <RedoOutlined />
        </Button>
        <Button
          className="text-primary"
          type="text"
          onClick={ () => {
            handleRotate(-90)
          } }>
          <UndoOutlined />
        </Button>
        <Button
          className="text-primary"
          type="text"
          onClick={ handleRestore }>
          重置
        </Button>

      </div>
      <div
        className={ Styles.imageContainer }
        ref={ containerRef }
        style={ {
          cursor: dragging
            ? 'grabbing'
            : 'grab'
        } }
        onMouseDown={ handleMouseDown }
      >
        <Image
          src={ currentSrc }
          alt="preview"
          preview={ false }
          draggable={ false }
          width="100%"
          style={ {
            width: '100%',
            position: 'absolute',
            transform: `
            translate(${ position.x }px, ${ position.y }px)
            scale(${ scale })
            rotate(${ rotation }deg)
          `,
            touchAction: 'none'
          } }
        />

      </div>
    </div>
  )
}

